import React from 'react'
import './Testimonials.scss'

interface Testimonial {
  name: string
  role: string
  company: string
  quote: string
  rating: number
}

const testimonials: Testimonial[] = [
  {
    name: 'Sarah Chen',
    role: 'Software Engineer',
    company: 'Anonymous Startup',
    quote: 'I landed 3 interviews in 2 weeks after using JobsReadyAI. The tailored resumes made all the difference - recruiters actually responded!',
    rating: 5
  },
  {
    name: 'Michael R',
    role: 'Product Manager',
    company: 'Fortune 500',
    quote: 'The interview prep questions were spot-on. I felt confident going into every interview and ended up with multiple offers.',
    rating: 5
  },
  {
    name: 'Emily P',
    role: 'Data Scientist',
    company: 'FAANG',
    quote: 'Saved me hours of work. Instead of spending days tailoring each application, I could focus on networking and preparing.',
    rating: 5
  }
]

function Testimonials() {
  return (
    <section className="testimonials-section py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <h2 
                className="fw-bold mb-3"
                style={{
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                  fontSize: '36px',
                  lineHeight: '44px',
                  letterSpacing: '-0.02em',
                  color: '#181a25'
                }}
              >
                Trusted by <span style={{ color: '#505fe2' }}>Job Seekers</span> Everywhere
              </h2>
              <p 
                className="text-muted"
                style={{
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                  fontSize: '18px',
                  lineHeight: '26px'
                }}
              >
                Join thousands of professionals who are landing more interviews
              </p>
            </div>

            <div className="row g-4 mb-5">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="col-md-4">
                  <div className="testimonial-card">
                    <div className="testimonial-rating">
                      {Array.from({ length: testimonial.rating }).map((_, i) => (
                        <span key={i} className="star">⭐</span>
                      ))}
                    </div>
                    <p className="testimonial-quote">"{testimonial.quote}"</p>
                    <div className="testimonial-author">
                      <div className="testimonial-author-info">
                        <strong className="testimonial-name">{testimonial.name}</strong>
                        <span className="testimonial-role">{testimonial.role}</span>
                        <span className="testimonial-company">{testimonial.company}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="stats-row text-center">
              <div className="row g-4">
                <div className="col-md-4">
                  <div className="stat-card">
                    <div className="stat-number">1,000+</div>
                    <div className="stat-label">Resumes Tailored</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="stat-card">
                    <div className="stat-number">2x</div>
                    <div className="stat-label">More Interview Requests</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="stat-card">
                    <div className="stat-number">85%</div>
                    <div className="stat-label">User Satisfaction</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Testimonials

